import $ from 'jquery';
import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./export-modal.html';
import moment from 'moment-timezone';
import '../../app/bindings/ko-bindinghandler-htmlSafe';
import MobileDetect from "mobile-detect";
import CaptureService from '../../modules/assurance/services/capture.service.js';
import html2canvas from 'html2canvas';
import LoginService from "../../services/login.service";
import _ from "lodash";
import DataProvider from "../../app/data-framework/data-provider";

var CAPTURED_IMAGE_LINK_ID = 'pageCapturedImageLink';

  function ExportModal(params) {

      var self = this;

      self.dataProvider = DataProvider.getInstance();

      self.working = ko.observable(false);

      self.captureImageLink = ko.observable(null);
      self.captureImageDownloadName = ko.observable(null);
      self.captureImageText = ko.observable('Please wait...');

      self.emailsubject = ko.observable();
      self.emailbody = ko.observable();

      self.message = ko.observable(null);

      self.attachmentMessage = ko.observable(null);

      var md = new MobileDetect(window.navigator.userAgent);
      var isIPhoneIpad = md.is('iPhone') || md.is('iPad');

      //alert("DeviceAgent:" + deviceAgent + " IsIpad:" + isIPhoneIpad);

      var _exportType = '';
      var _method = '';
      var _fileType = '';
      var _pageId = '';
      var _panelId = '';
      var _queryId = '';
      var _queryParams = null;
      var _reportElements = null;


      function captureImage(pageId, panelId) {
          var logDetails = panelId ? 'panel' : 'page';

          self.dataProvider.logActivity2('capturingImage', '', logDetails, {pageId: pageId, panelId: panelId});

          var username = LoginService.userObject.name;
          var nametokens = username.split(' ');
          var lastname = nametokens[nametokens.length - 1];

          var imageName = pageId + "_" + moment().format('YYYYMMDD_HHmmss') + "_" + lastname;

          self.working(true);
          self.captureImageText('Please wait...');
          self.captureImageLink(null);

          var source = panelId ? $('#' + panelId) : $('.wrapper');

          let bg = getComputedStyle(source.get(0)).getPropertyValue('--background-color');

          html2canvas(source[0], {
              svgRendering: true,
              logging: true,
              useCORS: true,
              allowTaint: true,
              backgroundColor: bg,
          }).then(function (canvas) {
              var linkEl = _.first($('#' + CAPTURED_IMAGE_LINK_ID));
              var imageNameWithExtension = imageName + '.png';

              canvas.toBlob(blob => {
                  if (typeof linkEl.download === 'undefined' && window.navigator.msSaveBlob) {
                      window.navigator.msSaveBlob(blob, imageNameWithExtension);
                  } else {
                      self.working(false);
                      self.captureImageDownloadName(imageNameWithExtension);

                      var url = window.URL.createObjectURL(blob);
                      self.captureImageLink(url);
                      self.captureImageText('Click to download');

                      linkEl.click();
                      window.URL.revokeObjectURL(url);
                  }
                  if (!self.isIPhoneIpad) {
                      _.first($('#ExportModal #modalclose')).click();
                  }
                  self.removeCanvas(source);
              });
          });
      }

      self.removeCanvas = function(context) {
        context.find('.screenShotTempCanvas').remove();
          context.find('.svgCaptureTempHide').show();
          context.find('.svgCaptureTempHide').each(function () {
              $(this).attr('class', $(this).attr('class').replace('svgCaptureTempHide', '').trim());
          });
      };

      self.initialize = function (exportType, method, fileType, pageId, panelId, queryId, queryParams, reportElements) {

          _exportType = exportType;
          _method = method;
          _fileType = fileType;
          _pageId = pageId;
          _panelId = panelId;
          _queryParams = queryParams;
          _queryId = queryId;

          _reportElements = reportElements;


          self.captureImageLink(null);
          self.captureImageDownloadName(null);

          self.message(null);
          self.emailsubject('');
          self.emailbody('');
          self.attachmentMessage(null);

          var ext = "." + (_fileType == 'image' ? 'png' : (_fileType == 'csv' ? 'csv/.zip' : _fileType));
          self.attachmentMessage(_queryId + ' &lt;identifier&gt;' + ext);
      };

      self.execute = function () {
          captureImage(_pageId, _panelId);
      };
  }


  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
  ExportModal.prototype.dispose = function () { };

  export default { viewModel: ExportModal, template: templateMarkup };
